export default {
  //弹框的标题
  dialogTitle: "选择成员",
  //弹框的宽度
  dialogWidth: "63%",
  //是否点击阴影部分关闭弹框
  dialogCloseOnClickModal: false,
  //点击保存时，校验必选
  required: false,
  //单选还是多选，checkbox，radio
  type: "checkbox",
  deptIds: [],
  //可选范围
  // 是否显示任职信息
  showPosition: false,
  // 是否启用添加到群组
  enableAddToGroup: true,
  // 添加到群组名称
  addButtonTabId: '2',
  showDepartment: true
};